import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import MyDialog from '@/components/MyDialog.vue';
import CharacterExportToVTT from './CharacterExportToVTT.vue';
import ConfirmDelete from '@/components/ConfirmDelete.vue';
import copy from 'copy-to-clipboard';
import { camelCase } from 'lodash';
import { saveAs } from 'file-saver';
let CharacterMenu = class CharacterMenu extends Vue {
    get printRoute() {
        return this.$router.currentRoute.path + '/print';
    }
    saveToFile() {
        const filename = (this.rawCharacter && this.rawCharacter.name) ? camelCase(this.rawCharacter.name) : 'incompleteCharacter';
        saveAs(new Blob([JSON.stringify(this.rawCharacter)], { type: 'text/plain;charset=utf-8;' }), filename + '.json');
        setTimeout(() => this.$emit('setClean'), 1000);
    }
    copyCharacter() {
        copy(JSON.stringify(this.rawCharacter));
        window.alert('Character data copied to clipboard!');
        this.$emit('setClean');
    }
};
__decorate([
    Prop(Object)
], CharacterMenu.prototype, "completeCharacter", void 0);
__decorate([
    Prop(Object)
], CharacterMenu.prototype, "rawCharacter", void 0);
__decorate([
    Prop(Object)
], CharacterMenu.prototype, "characterValidation", void 0);
CharacterMenu = __decorate([
    Component({
        components: {
            MyDialog,
            ConfirmDelete,
            CharacterExportToVTT
        }
    })
], CharacterMenu);
export default CharacterMenu;
